
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  withoutAssemblyAccessories: {
    id: "WithoutAssemblyAccessories.without",
    defaultMessage: "without assembly accessories",
  },
  withAssemblyAccessories: {
    id: "WithAssemblyAccessories.with",
    defaultMessage: "with assembly accessories",
  },
  withAssemblyAccessoriesTooltipHint: {
    id: "WithAssemblyAccessoriesTooltipHint.hint",
    defaultMessage: "Note:",
  },
  withAssemblyAccessoriesTooltipMessage: {
    id: "WithAssemblyAccessoriesTooltipMessage.message",
    defaultMessage: "Mounting by customer.",
  },
  withAssemblyAccessoriesTooltipMessageSafety: {
    id: "Assemblies.message.alwaysTriggerSafety",
    defaultMessage: "Trigger safety always included.",
  },
  assemblyAccessoriesLabelStainlessSteel: {
    id: "AssemblyAccessoriesLabelStainlessSteel.stainlesssteel",
    defaultMessage: "Stainless Steel",
  },
  assemblyAccessoriesLabelMiranit: {
    id: "AssemblyAccessoriesLabelMiranit.miranit",
    defaultMessage: "Miranit",
  },
  assemblyAccessoriesListConsole: {
    id: "AssemblyAccessoriesListConsole.console",
    defaultMessage: "Console",
  },
  assemblyAccessoriesListTriggerProtection: {
    id: "AssemblyAccessoriesListTriggerProtection.triggerprotection",
    defaultMessage: "Trigger Protection",
  },
  assemblyAccessoriesListAngleBar: {
    id: "AssemblyAccessoriesListAngleBar.anglebar",
    defaultMessage: "Angle Bar",
  },
  assemblyAccessoriesListFixingMaterial: {
    id: "AssemblyAccessoriesListFixingMaterial.fixingmaterial",
    defaultMessage: "Fixing Material",
  },
  assemblyAccessoriesStainlessSteelWhite: {
    id: "AssemblyAccessoriesStainlessSteelWhite.assemblyAccessoriesStainlessSteelWhite",
    defaultMessage: "Stainless Steel White",
  },
  consolesOverlapChoiceMessage: {
    id: "ConsolesOverlapChoice.message",
    defaultMessage: "Configuration not possible, please increase distance or select stainless steel console.",
  },
  consolesOverlapChoiceContinue: {
    id: "ConsolesOverlapChoice.continue",
    defaultMessage: "Return to original value (with MIRANIT console)",
  },
  consolesOverlapChoiceReturn: {
    id: "ConsolesOverlapChoice.return",
    defaultMessage: "Return to original value (with MIRANIT console)",
  },
  consolesOverlapChoiceChange: {
    id: "ConsolesOverlapChoice.change",
    defaultMessage: "Change to stainless steel console(s)",
  }
});

export default MESSAGES;